import { Component, h, Host, Prop } from '@stencil/core';
export class IllustrationComponent {
  constructor() {
    /**
     * The size of the illustration to be displayed on the banner
     */
    this.size = 'sm';
    /**
     * Determines the over-ride bottom margin size
     */
    this.bottomMargin = 'space04';
    /**
     * Adds alt text to images so that screen readers can announce the meaning of the image. Note this does not add the alt attribute but makes use of a hidden span tag to house the text
     */
    this.altText = '';
  }
  render() {
    return (h(Host, null,
      this.altText && h("span", { class: "sr-only" },
        "Image: ",
        this.altText),
      h("img", { "aria-hidden": "true", src: this.imagePath, class: { illustration: true, ['illustration__size--' + this.size]: true, ['agl-ds--bottom-margin-' + this.bottomMargin]: true } })));
  }
  static get is() { return "agl-ds-illustration"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["illustration.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["illustration.component.css"]
  }; }
  static get properties() { return {
    "imagePath": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The path of the illustration to be displayed"
      },
      "attribute": "image-path",
      "reflect": false
    },
    "size": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "IllustrationSize",
        "resolved": "\"lg\" | \"md\" | \"sm\" | \"xl\" | \"xs\"",
        "references": {
          "IllustrationSize": {
            "location": "import",
            "path": "./illustration.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The size of the illustration to be displayed on the banner"
      },
      "attribute": "size",
      "reflect": false,
      "defaultValue": "'sm'"
    },
    "bottomMargin": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "BottomMargin",
        "resolved": "\"none\" | \"space00\" | \"space01\" | \"space02\" | \"space03\" | \"space04\" | \"space05\" | \"space06\"",
        "references": {
          "BottomMargin": {
            "location": "import",
            "path": "../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride bottom margin size"
      },
      "attribute": "bottom-margin",
      "reflect": false,
      "defaultValue": "'space04'"
    },
    "altText": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Adds alt text to images so that screen readers can announce the meaning of the image. Note this does not add the alt attribute but makes use of a hidden span tag to house the text"
      },
      "attribute": "alt-text",
      "reflect": false,
      "defaultValue": "''"
    }
  }; }
}
